import { Edge } from "@xyflow/react";

import { DecisionConfirmationTypes } from "../../Course/enums/DecisionConfirmationTypes.enum";
import { FileTypes } from "../enums/FileTypes.enum";
import { PhaseEndResult } from "../enums/PhaseEndResult.enum";
import { PhaseEffect } from "../enums/PhaseEffect.enum";

interface IDecisionOption {
	option: string;
	phaseId: number;
}

export interface IStageContentInfo {
	id?: string;
	avatar?: { id: string | null; url: string | null };
	content: string;
	title?: string;
	startTimeInSeconds?: number;
	contentType: FileTypes;
	endTimeInSeconds?: number;
	timeStamp?: number;
	stageNumber?: number;
	autoplay?: boolean;
	isRemoved?: boolean;
}

export type ISpoilerContent = {
	content: string;
	title: string;
};

export type UploadedTempFile = {
	id: number;
	name: string;
	pageCount: number;
};

export type SelectedFileAndPage = {
	id: number | null;
	page: number | null;
	blank: boolean;
};

export type UploadedTempFilePage = {
	id: number;
	base64Url: string;
	createdAt?: Date;
	updatedAt?: Date;
	uploadedFileId: number;
	pageNumber: number;
};

export type CourseScenario = {
	scenarioName: string;
	author: string;
	Content: Array<{
		id: number | null;
		phaseName: string;
		timeLimit?: number;
		confirmationRequired: DecisionConfirmationTypes;
		phaseEndText?: string;
		phaseEndResult?: PhaseEndResult;
		timeLeftDecisionId: number;
		decisionName: string;
		spoilerContent?: ISpoilerContent;
		content: string;
		contentType: FileTypes;
		autoplay?: boolean;
		large?: boolean;
		decisionOptions: Array<IDecisionOption>;
		timeDelayedContent?: Array<IStageContentInfo>;
		effects?: Array<PhaseEffect>;
	}>;
	timeDelayedContent?: Array<IStageContentInfo>;
	Edges?: Edge[];
	uploadedFiles: UploadedTempFile[];
};

export const EMPTY_COURSE_SCENARIO: CourseScenario = {
	scenarioName: "",
	author: "",
	Content: [
		{
			id: null,
			phaseName: "",
			confirmationRequired: DecisionConfirmationTypes.NONE,
			decisionName: "",
			phaseEndText: "",
			phaseEndResult: PhaseEndResult.Success,
			content: "",
			contentType: FileTypes.Text,
			autoplay: false,
			large: false,
			decisionOptions: [
				{
					option: "",
					phaseId: 0,
				},
			],
			timeLeftDecisionId: 0,
			timeDelayedContent: [],
			effects: [],
		},
	],
	timeDelayedContent: [],
	Edges: [],
	uploadedFiles: [],
};
/*


{
	scenarioName: "",
	author: "",
	Content: [
		{
			id: null,
			phaseName: "",
			timeLimit: null,
			confirmationRequired: ConfirmationRequirement.NONE,
			decisionName: "",
			content: ["url-on-content1", "url-on-content2", "url-on-content3"],
			contentType: ContentType.URL,
			decisionOptions: [],
			timeLeftDecisionId: -1,
		},
	],
}


*/
